import React from "react";
import { useLocation } from "react-router-dom";
import MPMCModuleSubtopic from "../MPMCModuleSubtopic";

const MPMC_Arithmetic = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <MPMCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Arithmetic"
      videos={[
        "https://www.youtube.com/embed/cz5BSzcVyOY", // Arithmetic Instructions of 8051 Microcontroller
      ]}
      takeaways={[
        { text: "Understand how to perform arithmetic operations on multiple data values (e.g., adding 35H, 76H, 8AH, 97H, 92H)." },
        { text: "Learn how to perform arithmetic operations on data stored at specific memory locations (e.g., adding data stored at 200H)." },
        { text: "Familiarize yourself with ADD, ADC, SUBB, MUL, and DIV instructions in the 8051 microcontroller." },
      ]}
      questions={[]} // No specific previous questions provided
      exampleVideos={[]} // No example question videos provided
    />
  );
}

export default MPMC_Arithmetic;
